import { h } from "preact";

import classname from "../../../foundation/utils/classname";

import styles from "./Chip.module.css";

enum Background {
    Green = "green",
    Orange = "orange",
    Gray = "gray",
    Blue = "blue",
    Turquoise = "turquoise"
}

interface Props {
    class?: string;
    background?: Background;
    text: string;
    onClick?: (event: MouseEvent) => void;
}

function Chip({
    class: cssClass,
    background = Background.Green,
    text,
    onClick
}: Props) {
    return (
        <div class={classname(styles.chip, cssClass, styles[background])} onClick={onClick}>
            <span class="caption-2 semibold">
                {text}
            </span>
        </div>
    );
}

export default Chip;
export {
    Props as ChipProps,
    Background as ChipBackground
};
